function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h78v78H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.538 26.667h36.924L37.093 41.81c-.674.586-1.476.587-2.151 0L17.538 26.667zM15.692 29.417l12 10.604-12 11.396zM56.308 29.417v22l-12-11.414z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.3 41.333l11.238 11H18.462l11.291-10.981 2.997 2.704a4.87 4.87 0 0 0 6.552 0l2.997-2.723z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A1C4F4",
  fillRule: "nonzero",
  d: "M17.023 23C14.27 23 12 25.313 12 28.12v22.76c0 2.807 2.27 5.12 5.023 5.12h37.954C57.73 56 60 53.687 60 50.88V28.12c0-2.807-2.27-5.12-5.023-5.12H17.023zm.515 3.667h36.924L37.093 41.81c-.674.586-1.476.587-2.151 0L17.538 26.667zm-1.846 2.75l12 10.604-12 11.396v-22zm40.616 0v22l-12-11.414 12-10.586zM42.299 41.333l11.24 11H18.461l11.291-10.981 2.997 2.704a4.87 4.87 0 0 0 6.552 0l2.997-2.723z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M59 45.21c-5.398 0-9.79 4.392-9.79 9.79 0 5.398 4.392 9.79 9.79 9.79 5.398 0 9.79-4.392 9.79-9.79 0-5.398-4.392-9.79-9.79-9.79z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4E7EC2",
  fillRule: "nonzero",
  d: "M59 45.21c-5.398 0-9.79 4.392-9.79 9.79 0 5.398 4.392 9.79 9.79 9.79 5.398 0 9.79-4.392 9.79-9.79 0-5.398-4.392-9.79-9.79-9.79zm5.739 7.996l-6.236 5.85c-.19.177-.453.28-.722.28v.396l-.009-.396a1.059 1.059 0 0 1-.725-.293l-3.146-3.058a.916.916 0 0 1 .026-1.353 1.05 1.05 0 0 1 .708-.268c.28 0 .54.104.734.293l2.425 2.357 5.503-5.16c.192-.18.448-.28.72-.28.273 0 .53.1.722.28a.917.917 0 0 1 0 1.352z"
})));

var SvgRegistered = function SvgRegistered(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRegistered, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/registered.ea836c60.svg";
export { ForwardRef as ReactComponent };